module.exports = __webpack_public_path__ + "img/20191112152820984.b7c4eaf9.jpg";